import { Component } from '@angular/core';
import { ApplicationInsightsService } from './telemetry.service';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { StorageService } from './core/shared/services/storage.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Client-Bixi-BikeRepairApp';

  private appInsights: ApplicationInsightsService;

  constructor(
    private readonly router: Router,  
    private readonly storageService: StorageService) 
  {
    this.appInsights = new ApplicationInsightsService(router, storageService);
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event): event is ResolveEnd => event instanceof ResolveEnd))
      .subscribe((event) => {
        const activatedComponent = this.getActivatedComponent(event.state.root);
        if (activatedComponent) {
          this.appInsights.trackPageView({name:activatedComponent.name, uri: event.urlAfterRedirects});
        }
      });
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }
    return snapshot.component;
  }

}
